module.exports = __webpack_public_path__ + "static/media/CeraPro-Italic.dd59e6c7.ttf";